import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-exercise-icon',
    templateUrl: './exercise-icon.component.html',
    styleUrls: ['./exercise-icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ExerciseIconComponent implements OnInit {

  @Input() variant = 'outline';
  constructor() { }

  ngOnInit(): void {
  }

}
